import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M25,17v8H7V7H17V5H7A2,2,0,0,0,5,7V25a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V17Z"/><path d="M16,21a1.009,1.009,0,0,1-.641-.231l-6-5a1,1,0,1,1,1.282-1.536l5.171,4.31L25.187,5.419a1,1,0,1,1,1.626,1.162l-10,14a1,1,0,0,1-.685.411A1.113,1.113,0,0,1,16,21Z"/>';
export var CheckboxSVG = function CheckboxSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
CheckboxSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CheckboxSVG);